import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var fetchGeoLocation = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(position, setAddress) {
    var resData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("https://maps.googleapis.com/maps/api/geocode/json?latlng=".concat(parseFloat(position.coords.latitude), ",").concat(parseFloat(position.coords.longitude), "&key=AIzaSyCIKajdxnw25suNPzUQIVQzbBmxN9n4XrE")).then(function (response) {
              return response.json();
            }).then(function (data) {
              setAddress(data.results.length > 0 ? data.results[0].formatted_address : '');
              return data.formatted_address;
            });

          case 2:
            resData = _context.sent;
            _context.next = 5;
            return resData;

          case 5:
            return _context.abrupt("return", _context.sent);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchGeoLocation(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();